import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import CryptoJS from "crypto-js";
import io from "socket.io-client";
import Idle from "react-idle";
import Timer from "react-compound-timer";
import * as config from "configure/configServer.js";
import setMemberStatus from "actions/setMemberStatus.js";

// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import SweetAlert from "react-bootstrap-sweetalert";

import timeoutModal from "actions/timeoutModal.js";

// switch language function
import switchIntl from "configure/switchIntl.js";

// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
// import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
// import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import loadingScreen from "../views/Components/Loading.js";

import routes from "routes.js";

import appStyle from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";

import numberNoti from "actions/survey/count_noti.js";
import surveyModal from "actions/survey/surveyModal.js";

var ps;

class Dashboard extends React.Component {
  state = {
    mobileOpen: false,
    miniActive: false,
    image: require("assets/img/sidebar-2.jpg"),
    color: "white",
    bgColor: "white",
    hasImage: true,
    fixedClasses: "dropdown",
    logo: require("assets/img/logo-white.svg"),
    idleModal: null,
    getKey: undefined,
    noti: false,
    noti_number: [],
    noti_message: "",
    noti_status: "warning",
  };

  static propTypes = {
    loadingSet: PropTypes.string.isRequired,
    toggleLng: PropTypes.string.isRequired,
    logoutModal: PropTypes.object.isRequired,
    timeoutModal: PropTypes.object.isRequired,
    sessionPModal: PropTypes.object.isRequired,
  };

  mainPanel = React.createRef();

  handleSession_modal() {
    this.props.timeoutModal(
      <SweetAlert
        type="error"
        style={{
          display: "block",
          color: "black",
          fontSize: "18px",
        }}
        onConfirm={() => undefined}
        customClass="modalContent"
        title={switchIntl(this.props.toggleLng).sweetalert.timeoutModal.title}
        showCancel={false}
        showConfirm={false}
      >
        {switchIntl(this.props.toggleLng).sweetalert.timeoutModal.content}
      </SweetAlert>
    );
  }

  showNotification(data) {
    let noti_array = this.state.noti_number;
    noti_array.push(data);
    if (data[0].approved === 1) {
      this.setState({
        noti_number: noti_array,
        noti_message:
          "โครงการ " +
          data[0].nameth +
          " เลขแบบสอบถามที่ " +
          data[0].projectid +
          " ผ่านการอนุมัติแล้ว",
        noti_status: "success",
        noti: true,
      });
    } else {
      this.setState({
        noti_number: noti_array,
        noti_message:
          "โครงการ " +
          data[0].nameth +
          " เลขแบบสอบถามที่ " +
          data[0].projectid +
          " ไม่ผ่านการอนุมัติ",
        noti_status: "danger",
        noti: true,
      });
    }

    this.props.numberNoti(this.state.noti_number);

    setTimeout(() => {
      this.setState({
        noti: false,
      });
    }, 2500);
  }

  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", this.resizeFunction);

    var request = new Request(config.API_gen_secretkey, {
      method: "POST",
      headers: new Headers({ "Content-Type": "application/json" }),
    });

    fetch(request)
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.code === 200) {
          this.setState({
            getKey: responseJson.data,
          });

          const socket = io.connect(config.requestUrl, {
            transports: ["websocket"],
            forceNew: true,
          });
          socket.on("connect", () => {
            const that = this;
            const key = this.state.getKey;
            const keyutf = CryptoJS.enc.Utf8.parse(key);
            const iv = CryptoJS.enc.Base64.parse(key);
            var aesStr = localStorage.getItem("sessionP");
            if (!key || !aesStr) {
              setTimeout(() => {
                window.location.replace("/auth/");
              }, 1500);
              return;
            }
            const dec = CryptoJS.AES.decrypt(
              { ciphertext: CryptoJS.enc.Base64.parse(aesStr) },
              keyutf,
              {
                iv: iv,
              }
            );
            const decStr = CryptoJS.enc.Utf8.stringify(dec);
            const jsonDec = JSON.parse(decStr);

            var member_id = jsonDec.member_id;
            var tokenData = jsonDec.token;

            this.checkExpireToken(tokenData);
            //console.log('checkExpireToken')
            socket.on(member_id, (data) => {
              if (data !== tokenData) {
                this.handleSession_modal();
                // localStorage.removeItem("sessionP");
                localStorage.clear();
                setTimeout(() => {
                  window.location.replace("/auth/");
                }, 1500);
              } else {
              }
            });

            socket.on("noti:" + member_id, function(data) {
              that.showNotification(data);
            });
          });
        }
      })
      .catch((error) => {
        // console.log(error);
      });
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
    window.removeEventListener("resize", this.resizeFunction);
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.mainPanel.current.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }
  handleImageClick = (image) => {
    this.setState({ image: image });
  };
  handleColorClick = (color) => {
    this.setState({ color: color });
  };
  handleBgColorClick = (bgColor) => {
    switch (bgColor) {
      case "white":
        this.setState({ logo: require("assets/img/logo.svg") });
        break;
      default:
        this.setState({ logo: require("assets/img/logo-white.svg") });
        break;
    }
    this.setState({ bgColor: bgColor });
  };
  handleFixedClick = () => {
    if (this.state.fixedClasses === "dropdown") {
      this.setState({ fixedClasses: "dropdown show" });
    } else {
      this.setState({ fixedClasses: "dropdown" });
    }
  };
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute = () => {
    return window.location.pathname !== "/full-screen-maps";
  };
  getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return this.props.toggleLng === "TH"
            ? routes[i].thName
            : routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  sidebarMinimize = () => {
    this.setState({ miniActive: !this.state.miniActive });
  };
  resizeFunction = () => {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  };
  checkIdle(idle) {
    if (idle === true) {
      this.setState({
        idleModal: (
          <SweetAlert
            type="warning"
            style={{
              display: "block",
              color: "black",
              fontSize: "18px",
            }}
            customClass="modalContent"
            title={switchIntl(this.props.toggleLng).sweetalert.idelModal.title}
            onConfirm={() => this.setState({ idleModal: null })}
            confirmBtnCssClass="modalBt"
            confirmBtnText={
              switchIntl(this.props.toggleLng).sweetalert.idelModal.conBtTxt
            }
            showCancel={false}
          >
            {switchIntl(this.props.toggleLng).sweetalert.idelModal.content}
            <Timer
              initialTime={30000}
              direction="backward"
              checkpoints={[{ time: 0, callback: () => this.idelLogout() }]}
            >
              {() => (
                <React.Fragment>
                  <Timer.Seconds style={{ color: "green" }} />{" "}
                  {switchIntl(this.props.toggleLng).sweetalert.idelModal.unit}
                </React.Fragment>
              )}
            </Timer>
          </SweetAlert>
        ),
      });
    }
  }
  idelLogout() {
    const key = this.state.getKey;
    const keyutf = CryptoJS.enc.Utf8.parse(key);
    const iv = CryptoJS.enc.Base64.parse(key);

    var aesStr = localStorage.getItem("sessionP");
    if (!aesStr) {
      return;
    }
    const dec = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Base64.parse(aesStr) },
      keyutf,
      {
        iv: iv,
      }
    );
    const decStr = CryptoJS.enc.Utf8.stringify(dec);
    const jsonDec = JSON.parse(decStr);
    var tokenData = jsonDec.token;

    var request = new Request(config.API_logout, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        token: tokenData,
      }),
    });

    fetch(request)
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.code === 200) {
          this.setState({
            idleModal: (
              <SweetAlert
                type="error"
                style={{
                  display: "block",
                  color: "black",
                  fontSize: "18px",
                }}
                onConfirm={() => undefined}
                customClass="modalContent"
                title={
                  switchIntl(this.props.toggleLng).sweetalert.timeoutModal.title
                }
                showCancel={false}
                showConfirm={false}
              >
                {
                  switchIntl(this.props.toggleLng).sweetalert.timeoutModal
                    .content
                }
              </SweetAlert>
            ),
          });
          // localStorage.removeItem("sessionP");
          localStorage.clear();
          setTimeout(() => {
            window.location.replace("/auth/");
          }, 1500);
        }
      })
      .catch((error) => {
        //console.log(error);
      });
  }

  checkExpireToken(token) {
    var request = new Request(config.API_exptoken, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        token: token,
      }),
    });

    fetch(request)
      .then((response) => response.json())
      .then((responseJson) => {
        // console.log(responseJson)
        if ("data" in responseJson) {
          this.props.setMemberStatus(responseJson.data);
        }
        if (responseJson.message === "token not exp") {
        } else {
          this.expireModal();
        }
      })
      .catch(() => {
        // this.toggleModal("error");
        this.expireModal();
      });
  }

  expireModal() {
    this.props.timeoutModal(
      <SweetAlert
        type="error"
        style={{
          display: "block",
          color: "black",
          fontSize: "18px",
        }}
        onConfirm={() => undefined}
        customClass="modalContent"
        title={switchIntl(this.props.toggleLng).sweetalert.timeoutModal.title}
        showCancel={false}
        showConfirm={false}
      >
        {switchIntl(this.props.toggleLng).sweetalert.timeoutModal.content}
      </SweetAlert>
    );
    // localStorage.removeItem("sessionP");
    localStorage.clear();
    setTimeout(() => {
      window.location.replace("/auth/");
    }, 2000);
  }

  render() {
    const { classes, ...rest } = this.props;
    const mainPanel =
      classes.mainPanel +
      " " +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive,
        [classes.mainPanelWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1,
      });
    return (
      <Idle
        timeout={1800000}
        onChange={({ idle }) => this.checkIdle(idle)}
        // eslint-disable-next-line no-unused-vars
        render={({ idle }) => (
          <div className={classes.wrapper}>
            <Snackbar
              place="tc"
              color={this.state.noti_status}
              icon={AddAlert}
              message={this.state.noti_message}
              open={this.state.noti}
            />
            {loadingScreen(this.props.loadingSet)}
            {this.props.logoutModal}
            {this.props.sessionPModal}
            {this.state.idleModal}
            <Sidebar
              routes={routes}
              logoText={"Creative Tim"}
              logo={this.state.logo}
              image={this.state.image}
              handleDrawerToggle={this.handleDrawerToggle}
              open={this.state.mobileOpen}
              color={this.state.color}
              bgColor={this.state.bgColor}
              miniActive={this.state.miniActive}
              {...rest}
            />
            <div className={mainPanel} ref={this.mainPanel}>
              <AdminNavbar
                sidebarMinimize={this.sidebarMinimize.bind(this)}
                miniActive={this.state.miniActive}
                brandText={this.getActiveRoute(routes)}
                handleDrawerToggle={this.handleDrawerToggle}
                {...rest}
              />
              {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
              {this.getRoute() ? (
                <div className={classes.content}>
                  <div className={classes.container}>
                    <Switch>
                      {this.getRoutes(routes)}
                      <Redirect from="" to="/dashboard" />
                    </Switch>
                  </div>
                </div>
              ) : (
                <div className={classes.map}>
                  <Switch>
                    {this.getRoutes(routes)}
                    <Redirect from="" to="/dashboard" />
                  </Switch>
                </div>
              )}
              {/* {this.getRoute() ? <Footer fluid /> : null} */}
            </div>
          </div>
        )}
      />
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  timeoutModal: (payload) => dispatch(timeoutModal(payload)),
  numberNoti: (payload) => dispatch(numberNoti(payload)),
  surveyModal: (payload) => dispatch(surveyModal(payload)),
  setMemberStatus: (sta) => dispatch(setMemberStatus(sta)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(appStyle)(Dashboard));
